import produce from "immer";

const defaultState = {
    item: null,
    loading: true,
    found: false,
    submitting: false,
    missingFields: false,
    submitSuccess: false
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case 'FETCH_FORM_TEMPLATE':
            return produce(state, draft => {
                if (!action.silentRefetch) {
                    draft.item = null;
                    draft.loading = true;
                }
            });
        case 'FORM_TEMPLATE_FETCHED':
            return produce(state, draft => {
                draft.item = action.formTemplate;
                draft.loading = false;
                draft.found = true;
            });
        case 'FORM_TEMPLATE_NOT_FOUND':
            return produce(state, draft => {
                draft.loading = false;
                draft.found = false;
            });
        case 'SUBMIT_FORM_DATA':
            return produce(state, draft => {
                draft.submitting = true;
                draft.missingFields = false;
                draft.invalidPhoneNumber = false;
                draft.invalidEmailAddress = false;
            });
        case 'MISSING_FORM_FIELDS':
            return produce(state, draft => {
                draft.submitting = false;
                draft.missingFields = true;
            });
        case 'FORM_DATA_SUBMITTED':
            return produce(state, draft => {
                draft.submitting = false;
                draft.submitSuccess = true;
            });
        case 'INVALID_PHONE_NUMBER':
            return produce(state, draft => {
                draft.submitting = false;
                draft.invalidPhoneNumber = true;
            });
        case 'INVALID_EMAIL_ADDRESS':
            return produce(state, draft => {
                draft.submitting = false;
                draft.invalidEmailAddress = true;
            });
        default:
            return state;
    }
}